<template>
  <v-text-field
    :placeholder="placeholder"
    :label="label"
    :value="formattedValue"
    @input="updateValue"
    :outlined="outlined"
    :rules="fieldRules"
    v-bind="$attrs"
  ></v-text-field>
</template>

<script>
export default {
  props: {
    value: {
      required: true,
    },
    label: {
      type: String,
      required: false,
    },
    placeholder: {
      default: 'Digite o valor quantitativo',
    },
    outlined: {
      default: false,
    },
    rules: {
      type: Array,
      required: false,
    },
    required: {
      default: true,
      required: true,
    },
  },
  data() {
    return {
      stringValue: null,
    }
  },
  computed: {
    formattedValue() {
      return `${this.formatValue(this.stringValue)}`
    },
    fieldRules() {
      if (this.rules && this.rules.length) return this.rules
      return [this.requiredRule]
    },
    requiredRule() {
      return (value) => {
        if (!this.required) return true
        return (value != null && value !== '') || 'Campo obrigatório'
      }
    },
  },
  methods: {
    formatValue(value) {
      if (value) {
        const onlyValue = value.replace(/[^0-9]/g, '')
        const integerPart = onlyValue.slice(0, onlyValue.length - 2) || '0'
        const decimalPart = onlyValue.slice(-2)
        return `${this.removeLeadingZeros(integerPart)},${decimalPart}`
      }
      return ''
    },
    removeLeadingZeros(str) {
      return str.replace(/^0+(?=\d)/, '')
    },
    updateValue(value) {
      const onlyValue = value.replace(/[^0-9]/g, '')
      this.stringValue = onlyValue
      const numericValue = parseFloat(onlyValue) / 100
      this.$emit('input', numericValue)
    },
  },
  mounted() {
    if (this.value) {
      this.stringValue = parseFloat(this.value, 10).toFixed(2)
    }
  },
}
</script>
